export const appEnv = process.env.REACT_APP_LAYOUT_MANAGEMENT_KEY;
export const layoutManagementURL = process.env.REACT_APP_LAYOUT_MANAGEMENT_URL;
export const apiUrl = process.env.REACT_APP_API_URL;
export const pdfApiUrl = process.env.REACT_APP_PDF_API_URL;
export const pdfApiUrlApiKey = process.env.REACT_APP_PDF_API_KEY;
export const efiBaseURL = process.env.REACT_APP_EFI_BASE_URL;
